import React, { useEffect, useRef } from 'react';
import ResizableField from '../../../utility/resizableField';
import _ from 'lodash';
import { GridYValue } from '../../../constants';

export const LoginElement = function FromElement({ element, setPosition, innerElemHeight }) {
  const inputRef = useRef();

  const handlerWidthChange = (shift) => {
    var formAreaWidth = document.getElementsByClassName('form-area')[0].offsetWidth;

    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        width: Math.max(
          5,
          Math.min(100 - prevPosition.left, Math.floor((((prevPosition.startWidth / 100) * formAreaWidth + shift) / formAreaWidth) * 100)),
        ),
      };
    });
  };

  const finishWidthChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startWidth: prevPosition.width,
      };
    });
  };

  const handlerHeightChange = (shift) => {
    setPosition((prevPosition) => {
      const diff = Math.floor(shift / GridYValue);

      return {
        ...prevPosition,
        height: Math.max(11, prevPosition.startHeight + diff),
        innerElemHeight: Math.max(3, prevPosition.startInnerElemHeight + diff),
      };
    });
  };

  const finishHeightChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startHeight: prevPosition.height,
        startInnerElemHeight: prevPosition.innerElemHeight,
      };
    });
  };

  useEffect(() => {
    ResizableField(inputRef.current, handlerWidthChange, finishWidthChange, handlerHeightChange, finishHeightChange);
  }, [inputRef, element, element.options.width]);

  return (
    <>
      <label htmlFor={element.id} className="form-label">
        {element.options.label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
      </label>
      <div className="d-flex input-resizable-wrapper flex-wrap" style={{ height: innerElemHeight }}>
        <input
          name={element.options.name}
          id={element.id}
          ref={inputRef}
          type="text"
          readOnly
          style={{
            width: '100%',
            height: innerElemHeight,
            minHeight: 'unset',
          }}
          className={`form-control form-control-${element.options.size}`}
        />
      </div>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
